import request from "../utils/fetch";
//获取活动列表
// export function getActByStore (data) {
//   return request({
//     url: '/activityMsg/getActByStore',
//     method: 'get',
//     requestBody: 'query',
//     loading: true,
//     params: data
//   })
// }
// //获取所有活动类型
// export function getActType (data) {
//   return request({
//     url: '/activityMsg/getActType',
//     method: 'get',
//     requestBody: 'query',
//     loading: true,
//     params: data
//   })
// }
// export function addActivity (data) {
//   return request({
//     url: '/activityMsg/addActivity',
//     method: 'post',
//     requestBody: 'body',
//     loading: true,
//     data: data
//   })
// }
// export function updateActivity (data) {
//   return request({
//     url: 'activityMsg/updateActivity',
//     method: 'put',
//     requestBody: 'body',
//     loading: true,
//     data: data
//   })
// }
// export function switchAct (data) {
//   return request({
//     url: '/activityMsg/switchAct',
//     method: 'get',
//     requestBody: 'query',
//     loading: true,
//     params: data
//   })
// }
// export function delActivity (data) {
//   return request({
//     url: '/activityMsg/delActivity',
//     method: 'delete',
//     requestBody: 'query',
//     loading: true,
//     params: data
//   })
// }

//  首页
export function getOpHomePage(data) {
  return request({
    url: "/operate/homepage/getOpHomePage",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端订单统计

export function getOrderCount(data) {
  return request({
    url: "/operate/order/getOrderCount",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端订单列表

export function getOrderList(data) {
  return request({
    url: "/operate/order/getOrderList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 获取运营端订单详情

export function getOrderDetail(data) {
  return request({
    url: "/operate/order/getOrderDetail",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端仓库统计

export function getOperateHouseTotal(data) {
  return request({
    url: "/operate/house/getOperateHouseTotal",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端库存管理列表

export function getOperateHouseList(data) {
  return request({
    url: "/operate/house/getOperateHouseList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端库存详情统计

export function getOpHouseStockDetailTotal(data) {
  return request({
    url: "/operate/house/getOpHouseStockDetailTotal",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端仓库库存列表

export function getOperateHouseStockList(data) {
  return request({
    url: "/operate/house/getOperateHouseStockList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 获取运营端盘点统计

export function getCheckTotal(data) {
  return request({
    url: "/operate/house/getCheckTotal",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端盘点列表

export function getCheckList(data) {
  return request({
    url: "/operate/house/getCheckList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 获取运营端业务员数量
export function getSaleCount(data) {
  return request({
    url: "/operate/sale/getSaleCount",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端业务员列表

export function getSaleList(data) {
  return request({
    url: "/operate/sale/getSaleList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//获取运营端职位列表

export function getJobList(data) {
  return request({
    url: "/operate/job/getJobList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端区域统计
export function getCityTotal(data) {
  return request({
    url: "/operate/sale/getCityTotal",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端回收站总数

export function getBackStopCount(data) {
  return request({
    url: "/operate/backstop/getBackStopCount",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 获取运营端回收站列表

export function getBackStopList(data) {
  return request({
    url: "/operate/backstop/getBackStopList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取线索统计数据

export function getClueCount(data) {
  return request({
    url: "/operate/backstop/getClueCount",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取回收站申请列表

export function getBackStopClueList(data) {
  return request({
    url: "/operate/backstop/getBackStopClueList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//获取运营端物流账单列表
export function getHouseOutOrderCostList(data) {
  return request({
    url: "/operate/cost/getHouseOutOrderCostList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 根据key获取配置value

export function getValueByKey(data) {
  return request({
    url: "/config/getValueByKey",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 修改配置

export function addlst(data) {
  return request({
    url: "/config/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//获取运营端物流公司列表

export function getOpLogisticsList(data) {
  return request({
    url: "/operate/logistics/getOpLogisticsList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 获取运营详情

// export function getOperateInfo (data) {
//   return request({
//     url: '/operate/customer/getOperateInfo',
//     method: 'get',
//     requestBody: 'query',
//     loading: true,
//     params: data
//   })
// }
// 获取发送消息列表

export function getMessageList(data) {
  return request({
    url: "/operate/message/getMessageList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 快递信息查询

export function getexInfo(data) {
  return request({
    url: "/api/backOrder/expressInfo",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 审核盘点
export function checkyhx(data) {
  return request({
    url: "/operate/house/check",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 获取语音端盘点详情

export function getCheckInfo(data) {
  return request({
    url: "/operate/house/getCheckInfo",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 新增职位
export function getaddJob(data) {
  return request({
    url: "/operate/job/addJob",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
// 编辑

export function getdditJob(data) {
  return request({
    url: "/operate/job/editJob",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 获取运营端职位详情

export function getJobDetail(data) {
  return request({
    url: "/operate/job/getJobDetail",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端职位下员工数量
export function getSaleCountByJobId(data) {
  return request({
    url: "/operate/job/getSaleCountByJobId",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端区域详情

export function getCityDetail(data) {
  return request({
    url: "/operate/sale/getCityDetail",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取新增回收站表单列表数据
export function getAddBackStopForm(data) {
  return request({
    url: "/operate/backstop/getAddBackStopForm",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 修改或分配线索

export function checkClue(data) {
  return request({
    url: "/operate/backstop/checkClue",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 新增物流公司

export function addLogistics(data) {
  return request({
    url: "/operate/logistics/addLogistics",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 修改物流公司

export function editLogistics(data) {
  return request({
    url: "/operate/logistics/editLogistics",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

//禁用、启用物流公司

export function enableLogistics(data) {
  return request({
    url: "/operate/logistics/enableLogistics",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 获取发送消息列表

export function getSendMessageList(data) {
  return request({
    url: "/operate/message/getSendMessageList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 发送消息详情

export function getSendMessageDetail(data) {
  return request({
    url: "/operate/message/getSendMessageDetail",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 批量删除消息

export function batchDel(data) {
  return request({
    url: "/operate/message/batchDel",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 获取运营端业绩统计

export function getSaleAchiEveTotal(data) {
  return request({
    url: "/operate/sale/getSaleAchiEveTotal",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 审核账单
export function checkCost(data) {
  return request({
    url: "/operate/cost/checkCost",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 获取运营端物流账单详情

export function getHouseOutOrderCostDetail(data) {
  return request({
    url: "/operate/cost/getHouseOutOrderCostDetail",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 新增业务员

export function addSale(data) {
  return request({
    url: "/operate/sale/addSale",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 禁用、启用业务员

export function enableSale(data) {
  return request({
    url: "/operate/sale/enableSale",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 获取运营端业务员详情

export function getSaleDetail(data) {
  return request({
    url: "/operate/sale/getSaleDetail",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 编辑业务员

export function editSale(data) {
  return request({
    url: "/operate/sale/editSale",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 获取运营端回收站详情
export function getBackStopInfo(data) {
  return request({
    url: "/operate/backstop/getBackStopInfo",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 修改指定回收站状态

export function updateStatus(data) {
  return request({
    url: "/operate/backstop/updateStatus",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 发单

export function sendOrder(data) {
  return request({
    url: "/operate/order/sendOrder",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
// 批量已读消息

export function batchRead(data) {
  return request({
    url: "/operate/message/batchRead",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
// 修改线索状态
export function updateClueState(data) {
  return request({
    url: "/operate/backstop/updateClueState",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 获取运营端入库账单列表
export function getInOrderCostList(data) {
  return request({
    url: "/operate/cost/getInOrderCostList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端入库账单详情

export function getInOrderCostDetail(data) {
  return request({
    url: "/operate/cost/getInOrderCostDetail",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 获取运营端订单导出
export function getOrderExcel(data) {
  return request({
    url: "/operate/order/getOrderExcel",
    method: "get",
    requestBody: "download",
    loading: true,
    params: data,
  });
}

// 获取运营端入库账单导出
export function getInOrderCostExcel(data) {
  return request({
    url: "/operate/cost/getInOrderCostExcel",
    method: "get",
    requestBody: "download",
    loading: true,
    params: data,
  });
}

// 获取运营端物流账单导出
export function getHouseOutOrderCostExcel(data) {
  return request({
    url: "/operate/cost/getHouseOutOrderCostExcel",
    method: "get",
    requestBody: "download",
    loading: true,
    params: data,
  });
}

// 获取运营端业务员导出
export function getSaleExcel(data) {
  return request({
    url: "/operate/sale/getSaleExcel",
    method: "get",
    requestBody: "download",
    loading: true,
    params: data,
  });
}

// 获取运营端全部职位列表
export function getAllJobList(data) {
  return request({
    url: "/operate/job/getAllJobList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 新增回收站

export function addBackStop(data) {
  return request({
    url: "/operate/backstop/addBackStop",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 发送消息

export function sendMessage(data) {
  return request({
    url: "/operate/message/sendMessage",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

export function changeBackStopToSale(data) {
  return request({
    url: "/operate/sale/changeBackStopToSale",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 修改回收站

export function editBackStop(data) {
  return request({
    url: "/operate/backstop/editBackStop",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//

export function editWarnCount(data) {
  return request({
    url: "/admin/operate/editWarnCount",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

//
export function getWarnCount1(data) {
  return request({
    url: "/admin/operate/getWarnCount",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//
export function getLocation(data) {
  return request({
    url: "/region/getLocation",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
